import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import createRouter from './router/router'
import createStore from './store/store'
import UniqueId from 'vue-unique-id';
import registerGlobalVueFilters from './utils/vueFilters'
import setupValidation from './utils/validation'
import App from './App.vue';

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(UniqueId, { uidProperty: 'uid2' }); //import the unique id plugin (see https://www.npmjs.com/package/vue-unique-id) -> we have to change the uid property to uid2 bcs vue-select is using uid already....
registerGlobalVueFilters(Vue); //register all global filters
Vue.config.productionTip = true; //disable annoying tooltip

export default async function main({ settings, strings, enums, validationMessages, images }) {

    setupValidation(window.CONFIG.language, validationMessages);

    var store = await createStore(settings, strings, enums, images);
    var router = createRouter(settings, store);

    new Vue({
        el: '#migrol-shop',
        render: h => h(App),
        store,
        router
    });
}
